import Component from "../core/Component"
import { SearchPlugin } from "../plugins/SelectCore/plugins/SearchPlugin"
import { KeyboardPlugin } from "../plugins/SelectCore/plugins/KeyboardPlugin"
import { OffcanvasPlugin } from "../plugins/SelectCore/plugins/OffcanvasPlugin"
import { ClearValuePlugin } from "../plugins/SelectCore/plugins/ClearValuePlugin"
import SelectCore from "../plugins/SelectCore"

const PLUGINS = {
    search: SearchPlugin,
    keyboard: KeyboardPlugin,
    offcanvas: OffcanvasPlugin,
    clearvalue: ClearValuePlugin,
}

export default class Select extends Component {
    constructor(element, options = {}) {
        super(
            element,
            options = {
                plugins: ["search", "keyboard", "offcanvas"],
            }
        )

        this.selectCore = null
    }

    prepare() {
        const { plugins, ...options } = this.options
        this.selectCore = new SelectCore(this.element, options)
        plugins.forEach((pluginName) => this.selectCore.register(new PLUGINS[pluginName]()))
        this.selectCore.setup()
    }

    getSelectEl() {
        return this.selectCore.ref.select
    }
}